import moment from 'moment'
import { extendMoment } from 'moment-range'

export const isDateTimeInRange = (startDateTime, endDateTime, venueId, talks) => {
  // @ts-ignore
  const Moment_Range = extendMoment(moment)
  const startDateTimeInUTC = moment(startDateTime)
  const endDateTimeInUTC = moment(endDateTime)
  const range = Moment_Range.range(startDateTimeInUTC, endDateTimeInUTC)
  return talks.some((talk) => {
    const startDateUTC = moment(talk?.startDate)
    const endDateUTC = moment(talk?.endDate)
    const range1 = Moment_Range.range(startDateUTC, endDateUTC)
    return (range.overlaps(range1) || range1.overlaps(range)) && venueId === talk?.venueId
  })
}
